import { useEffect, useState } from 'react';
import { createContainer } from 'react-tracked';
import dark from './dark';
import light from './light';

const themes = {
  light,
  dark,
};

const useThemeState = () => {
  const [theme, _setTheme] = useState('dark');

  const setTheme = (themeName = 'dark') => {
    localStorage.setItem('theme', 'dark');
  };

  const toggleTheme = () => setTheme(theme == 'light' ? 'dark' : 'light');

  useEffect(() => {
    setTheme(localStorage.getItem('theme') || theme);
  }, []);

  return [theme, toggleTheme];
};

const { Provider, useTracked } = createContainer(useThemeState);

export const useTheme = useTracked;
export const ThemeProvider = ({ children }) => <Provider>{children}</Provider>;

export default ThemeProvider;
